import ActionStore from 'stores/action/ActionStore'
import EnumStore from 'stores/enum/EnumStore'
import FieldStore from 'stores/field/FieldStore'
import ModelStore from 'stores/model/ModelStore'
import ProjectStore from 'stores/project/ProjectStore'
import RecordStore from 'stores/record/RecordStore'
import ScriptStore from 'stores/script/ScriptStore'
import SessionStore from 'stores/session/SessionStore'
import TabStore from 'stores/tab/TabStore'

// Returns a legal topological order of all stores that extend BaseListStore
// Be careful if you change this. BootstrapStore will use this order to restore all stores (load them in memory from IndexedDB)
export default () => [
  ProjectStore,
  FieldStore,
  ModelStore,
  EnumStore,
  ScriptStore,
  RecordStore,
  SessionStore,
  ActionStore,
  TabStore,
]
